import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  Grid, 
  Stack
} from '@mui/material';
import { ApartmentType } from '@/types';
import ApartmentTypeCard from '@/components/apartmentType/ApartmentTypeCard';
import { useI18n } from '@/hooks/useI18n';

interface ApartmentTypesPageProps {
  apartmentTypes: ApartmentType[];
  onAddApartmentType: (scheme: Omit<ApartmentType, 'id'>) => void;
  onUpdateApartmentType: (scheme: ApartmentType) => void;
  onDeleteApartmentType: (schemeId: string) => void;
}

const ApartmentTypesPage: React.FC<ApartmentTypesPageProps> = ({ apartmentTypes, onAddApartmentType, onUpdateApartmentType, onDeleteApartmentType }) => {
  const { t } = useI18n();
  
  return (
    <Stack spacing={3}>
      <Grid container spacing={2}>
        {apartmentTypes.map((apartmentType) => (
          <Grid size={{ xs: 12, lg: 6, xl: 4 }} key={apartmentType.id}>
            <ApartmentTypeCard 
              apartmentType={apartmentType}
              onUpdateApartmentType={onUpdateApartmentType}
              onDeleteApartmentType={onDeleteApartmentType}
            />
          </Grid>
        ))}
      </Grid>

      {apartmentTypes.length === 0 && (
        <Card>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body1" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
              📋 {t('apartmentType.list.noTypesYet')}
            </Typography>
            <Typography variant="body2" color="text.disabled" sx={{ mt: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
              ➕ {t('apartmentType.list.addTypesHelp')}
            </Typography>
          </CardContent>
        </Card>
      )}
    </Stack>
  );
};

export default ApartmentTypesPage;
